import(/* webpackMode: "eager", webpackExports: ["DiscoverBanner"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/components/discover-banner.tsx");
